import NetworkUtil from "./NetworkUtil";
import {ServerResponse} from "../types/ServerResponse";

export default class ExemptionAPI {

  public static async filterExemptions(filter):Promise<{success:boolean, reason:string, data}>{
      return NetworkUtil.makePost("/api/admin/exemption/filter", filter)
  }

  public static async checkDuplicate(childFirstName: string, childLastName: string, childDOB: string, exemptionType: number):Promise<any>{
      return NetworkUtil.makePost("/api/admin/exemption/check-duplicate", {
          childFirstName,
          childLastName,
          childDOB,
          exemptionType
      });
  }
  
  public static async newExemption(exemptionInfo, ApprovalLetter):Promise<ServerResponse>{
    let data = new FormData()
    data.set('exemptionInfo', JSON.stringify(exemptionInfo))
    if(ApprovalLetter){
            data.append('approvalLetter', ApprovalLetter)
    }

    return await NetworkUtil.postForm("/api/admin/exemption/new", data);
  }

  public static editExemption(exemptionID: number, EducationSite?: object[], ChildDOB?: string):Promise<{ success: boolean; reason?: string }>{
    return NetworkUtil.makePost("/api/admin/exemption/edit", {
      exemptionID,
      EducationSite,
      ChildDOB
    });
  }

  public static async getExemptionCertificate(reqNum):Promise<any>{
    return await NetworkUtil.makePostForBuffer(`/api/admin/pdfReport/getLatestCertificateForReqNum`, {reqNum})
  }

  public static viewCertificate(path: string): Promise<any> {
    return NetworkUtil.makePostForBuffer("/api/admin/pdfReport/viewCertificate", { path: path });
  }

  // returns filePath of result report that is generated and stored in the cloud
  public static generateCertificateForReqNum(reqNum: string): Promise<{ success: boolean, reason: string, data }> {
    return NetworkUtil.makePost("/api/admin/pdfReport/generateResultReportForReqNum", { reqNum: reqNum })
  }
}